import {
  Box,
  Grid,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AnimationSlideLeft from "../../Animation/AnimationSlideLeft";
import aboutImg1 from "../../Assest/Images/Aboutus/image1.jpeg";
import aboutImg2 from "../../Assest/Images/Aboutus/image2.jpeg";
import aboutImg3 from "../../Assest/Images/Aboutus/image6.jpeg";
import aboutUsStudents from "../../Assest/Images/studentnew.svg";
import aboutUsAcademic from "../../Assest/Images/academicnew.svg";
import aboutUsAccreditaion from "../../Assest/Images/highschoolnew.svg";
import aboutUsAlumni from "../../Assest/Images/alumininew.svg";
import AnimationSlideBottom from "../../Animation/AnimationSlideBottom";
import AnimationSlideTop from "../../Animation/AnimationSlideTop";
import colors from "../../Assest/Theme/Color";
import useTranslations from "../Translations/useTranslations";
import { fetchData } from "../../BaseUrl";

console.log("aboutUsStudents", aboutUsStudents);

const about = [
  {
    name: "Students",
    imgSrc: aboutUsStudents,
  },
  {
    name: "Academic staff",
    imgSrc: aboutUsAcademic,
  },
  {
    name: "Accreditaion",
    imgSrc: aboutUsAccreditaion,
  },
  {
    name: "Alumni",
    imgSrc: aboutUsAlumni,
  },
];

function AboutUsPage() {
  useTranslations();
  const isMobile = useMediaQuery("(max-width:600px)");
  const styles = {
    container: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#f9f5ff",
      padding: isMobile ? "" : "0 4rem",
    },

    heading: {
      fontSize: isMobile ? "20px" : "26px",
      fontWeight: "bold",
      color: colors.secondary,
      marginBottom: "10px",
      textAlign: "left",
    },
    subheading: {
      fontSize: isMobile ? "20px" : "30px",
      fontWeight: "bold",
      color: colors.lightText,
      marginBottom: "5px",
      textAlign: "left",
      lineHeight:1.1
    },
    subText: {
      textAlign: "justify",
      color: colors.lightText,
    },
    subText1: {
      textAlign: "justify",
      color: colors.lightText,
      fontSize: "14px",
    },

    teacherHead: {
      fontSize: "32px",
      fontFamily: "Caveat, serif",
      fontWeight: "bold",
      color: colors.secondary,
      marginBottom: "10px",
    },
  };

  const [aboutData, setAboutData] = useState([]);

  useEffect(() => {
    getAbout();
  }, []);
  
  const getAbout = async () => {
    try {
      const response = await fetchData("/admin/about-us/list");
      if (response?.data?.length) {
        setAboutData(response.data); 
        console.log("About Data:", response.data);
      } else {
        setAboutData([]);
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
      setAboutData([]);
    }
  };

  console.log("aboutData", aboutData)
  

  return (
    <div style={{ overflow: "hidden", paddingTop: isMobile ? "4rem" : "6rem" }}>
      <Box sx={styles.container} mt={2}>
        <Grid container spacing={4}>
          <Grid
            item
            xs={12}
            md={6}
            p={isMobile ? 1 : 2}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Grid container spacing={4}>
              <Grid
                item
                xs={6}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <AnimationSlideLeft duration={1.2} rootMargin={"-10px"}>
                  <img
                    src={aboutImg1}
                    style={{
                      height: isMobile ? "200px" : "320px",
                      width: isMobile ? "125px" : "250px",
                      borderRadius: "15px",
                      marginLeft: isMobile ? "2rem" : "",
                    }}
                    alt="aboutImg1"
                  />
                </AnimationSlideLeft>
              </Grid>
              <Grid item xs={6} sm={6} sx={{textAlign:'start'}}>
                <AnimationSlideBottom duration={1} rootMargin={"-10px"}>
                  <img
                    src={aboutImg2}
                    style={{
                      height: isMobile ? "100px" : "180px",
                      width: isMobile ? "100px" : "180px",
                      borderRadius: "15px",
                      marginRight: "2rem",
                    }}
                    alt="aboutImg2"
                  />
                </AnimationSlideBottom>
                <AnimationSlideTop duration={1.3} rootMargin={"-10px"}>
                  <img
                    src={aboutImg3}
                    style={{
                      height: isMobile ? "180px" : "280px",
                      width: isMobile ? "125px" : "230px",
                      borderRadius: "15px",
                      marginTop: "20px",
                      marginRight: isMobile ? "2rem" : "",
                    }}
                    alt="aboutImg3"
                  />
                </AnimationSlideTop>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box sx={{ p: isMobile ? "0 2rem" : 4 }}>
              <AnimationSlideBottom duration={1} rootMargin={"-10px"}>
                <Typography sx={styles.heading}>
                {/* {aboutData.find((item) => item.id === 1)?.content || "No content available"} */}
                ABOUT US
                </Typography>
              </AnimationSlideBottom>
              {/* <AnimationSlideRight duration={1.2} rootMargin={"-100px"}> */}
              <Typography sx={styles.subheading}>
                "தலைமுறை தாண்டும்
              </Typography>
              <Typography sx={{ ...styles.subheading, marginBottom: '3%' }}>
                <span style={{color:colors.secondary}}>தமிழே</span> எங்கள் இலக்கு"
              </Typography>
              {/* </AnimationSlideRight> */}
              <Typography sx={styles.subText}>
                {/* {aboutData.find((item) => item.id === 3)?.content || "No content available"} */}
                Cumming Tamil School was founded in August 2019 in the South Forsyth area serving the Tamil community with language education on Friday evenings to 450+ kids between the ages of 5 and 18. We are accredited by the Georgia Accreditation Commission enabling us to work with School Districts to award a high school world language credit. In addition we are accredited by Cognia for our education standards.
              </Typography>
               <Typography sx={styles.subText}>
              We are a proud Guinness World Record holder and all of our students are authors publishing books every year. We strive to bring fun-filled, interesting, and yet very productive ways to keep the next generation motivated to learn the language and take it forward. Our alumni students always are welcomed back as paraprofessional volunteers.We follow the curriculum laid down by American Tamil Academy (ATA).</Typography>
              {/* <AnimationSlideBottom duration={1} rootMargin={"-10px"}>
                <Typography sx={styles.heading} mt={1}>
                {aboutData.find((item) => item.id === 2)?.content || "No content available"}
                </Typography>
              </AnimationSlideBottom> */}
              {/* <Typography sx={styles.subText1}>
              {aboutData.find((item) => item.id === 4)?.content || "No content available"}
              </Typography> */}

              {/* <Typography sx={styles.subheading}>
              {aboutData.find((item) => item.id === 5)?.content || "No content available"}
              </Typography> */}
              {/* <Typography sx={styles.subheading}>
                Our motto : “தலைமுறை தாண்டிய தமிழே எங்கள் இலக்கு”
              </Typography> */}
              <Grid container mt={2}>
                <Grid item xs={12} md={12}>
                  {/* <AnimationSlideRight duration={1.2} rootMargin={"-10px"}>
                    <div
                      style={{
                        display: "flex",
                        gap: 10,
                        justifyContent: "center",
                        marginTop: "10px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <img
                          style={{
                            backgroundColor: colors.secondary,
                            borderRadius: "50%",
                            padding: "5px",
                          }}
                          width="50"
                          height="50"
                          src="https://img.icons8.com/plasticine/100/saving-book.png"
                          alt="saving-book"
                        />
                      </div>
                      <div style={{ textAlign: "left", marginTop: "5px" }}>
                        <Typography
                          sx={{
                            // fontFamily: "Island Moments, serif",
                            fontSize: isMobile ? "16px" : "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {translations.educationServices}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: isMobile ? "12px" : "14px",
                          }}
                        >
                          {translations.educationDescription}
                        </Typography>
                      </div>
                    </div>
                  </AnimationSlideRight> */}
                  {/* <AnimationSlideRight duration={1.2} rootMargin={"-10px"}>
                    <div
                      style={{
                        display: "flex",
                        gap: 10,
                        justifyContent: "center",
                        marginTop: "20px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <img
                          style={{
                            backgroundColor: colors.secondary,
                            borderRadius: "50%",
                            padding: "5px",
                          }}
                          width="50"
                          height="50"
                          src="https://img.icons8.com/isometric/50/literature.png"
                          alt="literature"
                        />
                      </div>
                      <div style={{ textAlign: "left", marginTop: "5px" }}>
                        <Typography
                          sx={{
                            fontSize: isMobile ? "14px" : "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {translations.eLearningServices}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: isMobile ? "12px" : "14px",
                          }}
                        >
                          {translations.eLearningDescription}
                        </Typography>
                      </div>
                    </div>
                  </AnimationSlideRight> */}

                  {/* <AnimationSlideTop duration={0.8} rootMargin={"100px"}>
                    <div style={{ marginTop: "20px" }}>
                      <Button
                        sx={{
                          backgroundColor: colors.lightButton,
                          color: colors.black,
                          borderRadius: "10px",
                          textTransform: "capitalize",
                          display: "flex",
                          justifyContent: "flex-start",
                          padding: "8px 14px",
                        }}
                      >
                        {translations.exploreMore}
                      </Button>
                    </div>
                  </AnimationSlideTop> */}
                </Grid>
                {/* <Grid item xs={12} md={5} px={isMobile ? 0 : 2}>
                  <div
                    style={{
                      backgroundColor: colors.white,
                      borderRadius: "10px ",
                      padding: "5px 20px",
                      textAlign: "justify",
                      margin: isMobile ? "2rem 0" : 0,
                    }}
                  >
                    <p>
                      "Learning ignites the heart and mind, guiding us to grow,
                      explore, and discover. Each lesson lifts us higher, with
                      education lighting the way."
                    </p>
                  </div>
                </Grid> */}
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Grid container spacing={3} mt={3} mb={5}>
      {about.map((item, index) => (
          <Grid item xs={12} sm={3} key={index}>
            <AnimationSlideTop duration={1} rootMargin={"-10px"}>
              <div
                style={{
                  height: "200px",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img src={item.imgSrc} alt={item.name} />
              </div>
              <Typography sx={{ml:1}} component="div">{item.name}</Typography>
            </AnimationSlideTop>
          </Grid>
        ))}
      </Grid>

      {/* <div style={{ padding: "2rem 0" }}>
        <AnimationSlideBottom duration={1} rootMargin={"-10px"}>
          <p style={styles.teacherHead}>{translations.teachersHeader}</p>
        </AnimationSlideBottom>
        <AnimationSlideLeft duration={1.2} rootMargin={"-10px"}>
          <p
            style={{
              fontWeight: "bold",
              fontSize: isMobile ? "20px" : "28px",
              margin: 0,
            }}
          >
            {translations.meetWithTeachers}{" "}
            {languageSelect === "Tamil" ? null : (
              <span style={{ color: colors.secondary }}>
                {" "}
                {translations.teachers}
              </span>
            )}
          </p>
        </AnimationSlideLeft>
        <AnimationSlideRight duration={1.4} rootMargin={"-10px"}>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <p
              style={{
                width: isMobile ? "90%" : "50%",
                textAlign: isMobile ? "justify" : "center",
              }}
            >
              {translations.teacherDescription}
            </p>{" "}
          </div>
        </AnimationSlideRight>
        <TeacherList />
      </div> */}
    </div>
  );
}

export default AboutUsPage;
